import guide from '../../../../docs/inbound-schema-user-guide.md?raw';

type HelpBlock = { kind: 'code' | 'paragraph'; text: string };

export const inboundSchemaHelpSections = guide.replace(/\r\n/g, '\n').split(/^## /m).slice(1).map(section => {
  const newline = section.indexOf('\n');
  const title = section.slice(0, newline).trim();
  const body = section.slice(newline).trim();
  const blocks = body.split(/(```json\n[\s\S]*?\n```)/).filter(block => block.trim()).flatMap<HelpBlock>(block =>
    block.startsWith('```json\n')
      ? [{ kind: 'code' as const, text: block.slice(8, -4) }]
      : block.trim().split(/\n\s*\n/).map(text => ({ kind: 'paragraph' as const, text })));
  return { title, id: title.toLowerCase().replace(/\s+/g, '-'), blocks };
});